import Blank from '@doltech/ui/lib/figma/BlankEditor/DoTest/Blank';
import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { Box } from '@doltech/ui/lib/figma/Common/Box';
import { QuestionV2 } from '@doltech/ui/lib/figma/Question/QuestionV2';
import cl from 'classnames';
import { get } from 'lodash';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import styled from 'styled-components';

import { DoTestShortQuestionInstance } from '../student-do-test/model/Question/do-test-short-question.store';
import { useTestSubmissionStore } from '../student-do-test/model/test-submissions.hook';
import { FontSizeElementVariants } from '@doltech/ui/lib/figma/DolEditor/decorators/font-size-switcher/components/FontSizeSwitcherElement.types';
import { DoTestEditor } from '@doltech/ui/lib/figma/DoTestEditor/DoTestEditor';
import { isJson } from '@doltech/utils/lib/object';
import { ResponsiveTypography } from '@doltech/ui/lib/figma/Typography/v3/ResponsiveTypography';

export const Main = styled(Box)`
  background-color: unset;
  border-radius: unset;
  box-shadow: unset;
  padding: unset;
  margin-top: 16px;
`;

export const SentenceGrid = styled.div`
  display: grid;
  grid-template-columns: 100%;
  align-items: center;
  gap: 12px;

  background-color: ${colorsV2.white100};
  border-radius: 16px;
  box-shadow: 0 2px 2px ${colorsV2.blackShadow5};
  padding: 16px;
`;

const BlankWrapper = styled.span`
  .blank-container {
    line-height: 24px;
  }
`;

const TextWrapper = styled.div`
  font-weight: 400;
  line-height: 28px;
  font-size: 14px;
  margin-top: -2px;
  margin-bottom: 2px;
  display: flex;
  .question-no {
    display: inline-block;
    margin-right: 12px;
  }
`;

export const Container = styled.div`
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  color: ${colorsV2.black100};
`;

interface ShortAnswerProps {
  data: DoTestShortQuestionInstance;
}

export const ShortAnswer = observer((props: ShortAnswerProps) => {
  const { data } = props;
  if (!data) return null;
  const { sentences, no, userAnswers, onAnswerQuestion, setQuestion } = data;
  const store = useTestSubmissionStore();
  const getUserAnswer = React.useCallback(
    (id) => {
      return get(
        userAnswers.find((it) => it.blankId === id),
        'userAnswer'
      );
    },
    [userAnswers]
  );

  return (
    <Main className="dol-question short-answer">
      <SentenceGrid>
        {sentences.map((item, index) => {
          return (
            <Container
              className={cl('short-answer-container')}
              key={item.key}
              id={`question-no-${no + index}`}
            >
              <TextWrapper>
                <div className="question-no">
                  <QuestionV2 no={no + Number(item.key)} marginRight={0} />
                </div>
                <ResponsiveTypography.Text
                  variant="regular/14-20"
                  className="question-sentence"
                  color="black100"
                >
                  {' '}
                  <DoTestEditor
                    initialValue={
                      isJson(item.text)
                        ? JSON.parse(item.text)
                        : [
                            {
                              type: FontSizeElementVariants.PARAGRAPH,
                              children: [
                                {
                                  text: item.text ?? '',
                                },
                              ],
                            },
                          ]
                    }
                    readOnly
                    onChange={(value) => setQuestion({ key: item.key, value })}
                  />
                </ResponsiveTypography.Text>
                <BlankWrapper>
                  <Blank
                    id={item.key.toString()}
                    no={no + Number(item.key)}
                    value={getUserAnswer(item.key.toString())}
                    className="blank-container"
                    showRemoveButton={false}
                    onChange={(input) => {
                      if (store.preventUserAction()) return;
                      onAnswerQuestion(input);
                    }}
                    showQuestionNo={false}
                  />
                </BlankWrapper>
              </TextWrapper>
            </Container>
          );
        })}
      </SentenceGrid>
    </Main>
  );
});
